var React = require('react');

function CheckGreenInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.1926 23.8125L6.93762 17.5575L4.80762 19.6725L13.1926 28.0575L31.1926 10.0575L29.0776 7.9425L13.1926 23.8125Z","fill":"#59B89F"}));
}

CheckGreenInline.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = CheckGreenInline;

CheckGreenInline.default = CheckGreenInline;
